
    import './styles.scoped.css';
    export default {
  "progress": "awsui_progress_11huc_up0fd_197",
  "result-state": "awsui_result-state_11huc_up0fd_211",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_11huc_up0fd_1",
  "root": "awsui_root_11huc_up0fd_233",
  "with-result-button": "awsui_with-result-button_11huc_up0fd_268",
  "result-text": "awsui_result-text_11huc_up0fd_272",
  "result-container-error": "awsui_result-container-error_11huc_up0fd_276",
  "result-container-success": "awsui_result-container-success_11huc_up0fd_276",
  "result-button": "awsui_result-button_11huc_up0fd_280",
  "word-wrap": "awsui_word-wrap_11huc_up0fd_286",
  "label-flash": "awsui_label-flash_11huc_up0fd_291",
  "label-key-value": "awsui_label-key-value_11huc_up0fd_295",
  "flash": "awsui_flash_11huc_up0fd_303",
  "progress-container": "awsui_progress-container_11huc_up0fd_307",
  "percentage-container": "awsui_percentage-container_11huc_up0fd_314",
  "percentage": "awsui_percentage_11huc_up0fd_314",
  "complete": "awsui_complete_11huc_up0fd_360",
  "progress-in-flash": "awsui_progress-in-flash_11huc_up0fd_388"
};
  